// extracted by mini-css-extract-plugin
module.exports = {"badgeClaimLink":"GuideStepperItem_badgeClaimLink__MN4sn"};